import {KzAusgabe1CalculationData, KzAusgabe1Strategy} from './kz-ausgabe-1.strategy';
import {Dictionary} from '@softline/core';

export class KzAusgabe1InputCalculationStrategy implements KzAusgabe1Strategy {
  calculate(data: KzAusgabe1CalculationData): Dictionary<number | null> {
    data.dict[data.ausgabeEh1.id] = Math.ceil(data.inputValue * data.inputArteh.faktor)
    return data.dict
  }
}
